module.exports = __webpack_public_path__ + "img/tick_square.4e5ea0bf.svg";